import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LocaleProvider } from './contexts/LocaleContext';

const root = createRoot(document.getElementById('root'));

root.render(
  <LocaleProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </LocaleProvider>
);
